import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { RightsService } from './rights.service';
import { Observable } from 'rxjs';
import { Right } from '../models/Rights.enum';

@Injectable()
export class CheckAccessService implements CanActivate {

  constructor(private rightsService: RightsService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const isRightArray = Array.isArray(route.data.accessRight);
    let canAccess: boolean;

    if (isRightArray) {
      const rightsList: Right[] = route.data.accessRight;
      canAccess = rightsList.every(right => this.rightsService.hasAccessRights(right));
    } else {
      canAccess = this.rightsService.hasAccessRights(route.data.accessRight);
    }

    if (!canAccess) {
      this.router.navigate(['/home']);
    }
    return canAccess;
  }
}
